import { Typography } from '@mui/material';
import { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import getConfig from 'next/config';
import EirFooter from '../../../../../components/eir-footer/EirFooter';
import EirHeader from '../../../../../components/eir-header/EirHeader';
import EirMetaTag from '../../../../../components/eir-meta-tag/EirMetaTag';
import NotificationBanner from '../../../../../components/eir-notification-banner/NotificationBanner';
import PrepayHandsetsContainer from '../../../../../components/eir-prepay/prepay-handsets/PrepayHandsetsContainer';
import { clearAllCookies, getCookie } from '../../../../../hooks/useCookie';
import getStrapiData from '../../../../../integration/strapi';

export async function getServerSideProps() {
  let cmsHeaderData = {};
  let cmsFooterData = {};
  const cmsData = await getStrapiData('prepay-handset');
  cmsHeaderData = await getStrapiData('header');
  cmsFooterData = await getStrapiData('footer');

  return {
    props: {
      cmsData: cmsData?.data,
      cmsHeaderData,
      cmsFooterData,
    },
  };
}

/**
 * @name PrepayHandsets
 * @description Page which loads prepay mobile journey
 * @param {object} cmsData - Strapi object for prepay-mobile
 * @param {object} cmsHeaderData - Strapi object for header
 * @param {object} cmsFooterData - Strapi object for footer
 * @returns {JSX.Element} - Returns Prepay Mobile Page
 */
const PrepayHandsets = ({ cmsData, cmsHeaderData, cmsFooterData }) => {
  const { publicRuntimeConfig } = getConfig();
  const theme = useTheme();
  useEffect(() => {
    const hasReload = sessionStorage.getItem('hasReload');
    const hasReference = getCookie('PREPAY_REFERENCE');
    const currentPath = window.location.pathname;
    const isPrepapayPage = currentPath.includes('/shop/mobile/prepay');
    if (isPrepapayPage && hasReload === 'true') {
      sessionStorage.removeItem('hasReload');
    }

    if (!hasReference && !hasReload) {
      // If no prepay reference found clear all the stroage

      sessionStorage.setItem('hasReload', 'in-progress');
      clearAllCookies();
      localStorage.clear();
      window.location.reload();
    } else if (hasReference) {
      sessionStorage.removeItem('hasReload');
    } else if (hasReload === 'in-progress') {
      sessionStorage.setItem('hasReload', 'true');
    }
  }, []);
  return (
    <>
      <EirMetaTag seo={cmsData?.attributes?.seoHandsets} />
      <EirHeader cmsHeaderData={cmsHeaderData?.data} />
      <main id='main' tabIndex={-1}>
        <NotificationBanner
          desktopText={
            <Typography component='p' variant='body1'>
              <Typography
                component='span'
                variant='subtitle1'
                color={theme.palette.primary.textColor3}
                sx={{ display: 'inline' }}
              >
                Already with us?
              </Typography>
              <Typography
                component='span'
                color={theme.palette.primary.textColor3}
                sx={{ display: 'inline', marginLeft: theme.spacing(2) }}
              >
                Upgrade as an existing customer
              </Typography>
            </Typography>
          }
          mobileText='Already with us?'
          cta={{
            ctaText: 'Exisiting eir Prepay',
            ariaLabel: 'Exisiting eir Prepay',
            type: 'solid',
            action: () => {
              window.location.href = `${publicRuntimeConfig.NEXT_PUBLIC_OPENCMS}/store/mobile/phones/prepay`;
            },
            disableCta: false,
          }}
        />
        <PrepayHandsetsContainer cmsData={cmsData} />
      </main>
      <EirFooter cmsFooterData={cmsFooterData?.data} />
    </>
  );
};

export default PrepayHandsets;
